// src/context/AuthContext.jsx (refactorizado)
import React, { createContext, useContext, useState, useEffect } from 'react';
import AuthService from '../services/AuthService';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState('');
  const [loading, setLoading] = useState(true);

  // Verificar el estado de autenticación cuando se monta el componente
  useEffect(() => {
    const checkAuthStatus = () => {
      const authenticated = AuthService.isAuthenticated();
      setIsAuthenticated(authenticated);
      
      if (authenticated) {
        setUser(AuthService.getUser() || '');
      }
      
      setLoading(false);
    };
    
    checkAuthStatus();
  }, []);

  const login = async (username, password) => {
    const success = await AuthService.login(username, password);
    
    if (success) {
      setIsAuthenticated(true);
      setUser(AuthService.getUser() || '');
    }
    
    return success;
  };

  const logout = () => {
    AuthService.logout();
    setIsAuthenticated(false);
    setUser('');
  };

  // Para verificar si el token está activo
  const hasValidToken = () => {
    return AuthService.isAuthenticated() && !AuthService.isSessionExpired();
  };

  return (
    <AuthContext.Provider 
      value={{ 
        isAuthenticated, 
        user, 
        login, 
        logout, 
        hasValidToken,
        loading
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

// Hook para usar el AuthContext
export function useAuth() {
  return useContext(AuthContext);
}